import React from "react";
import "./styles.scss";
import classnames from "classnames";

type AlcoholGlassIconProps = {
  className?: string;
};

const AlcoholGlassIcon: React.ComponentType<AlcoholGlassIconProps> = ({
  className,
}) => (
  <span className={classnames("AlcoholGlassIcon", className && className)}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.2"
      overflow="visible"
      preserveAspectRatio="none"
      viewBox="0 0 26 26"
    >
      <g transform="translate(1, 1)">
        <g>
          <path
            d="M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9zM7.43 7L5.66 5h12.69l-1.78 2H7.43z"
            vectorEffect="non-scaling-stroke"
          />
        </g>
      </g>
    </svg>
  </span>
);

export default AlcoholGlassIcon;
